<template>
    <el-container>
        <el-main style="padding: 0;">
            <el-table :data="dataList" style="border: none;min-height: 400px" class="custom-table"
                :row-style="{ 'max-height': '60px' }">
                <el-table-column prop="typeName" label="证书" width="150">
                </el-table-column>

                <el-table-column prop="name" label="内容" width="300">
                </el-table-column>
                <el-table-column prop="description" label="备注" width="300">
                </el-table-column>
                <el-table-column prop="date" label="日期" width="180">
                </el-table-column>
                <el-table-column prop="startDate" label="生效日期" width="180">
                </el-table-column>
                <el-table-column prop="endDate" label="截止日期" width="180">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-row>
                            <el-button type="primary" size="mini" icon="el-icon-edit" circle
                                @click="openDialog(scope.row)"></el-button>
                        </el-row>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 弹窗 -->
            <div v-if="isDialogVisible" class="dialog-mask">
                <div class="dialog-content" style="max-height: 750px;">
                    <h3 style="margin-bottom: 20px;">分配</h3>
                    <el-table ref="multipleTable" :data="currentData" tooltip-effect="dark" height="600"
                        style="width: 100%;" row-key="id">
                        <!-- <el-table-column type="selection" width="60">
                        </el-table-column> -->
                        <el-table-column label="选择" width="55">
                            <template #default="scope">
                                <el-checkbox v-model="scope.row.isCert" >
                                </el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column prop="code" label="产品编码" width="180">
                        </el-table-column>
                        <el-table-column prop="name" label="产品名称" width="500">
                        </el-table-column>
                    </el-table>
                    <div class="button-group">
                        <el-button size="mini" round @click="saveProduct">确认</el-button>
                        <el-button size="mini" round @click="closeDialog">取消</el-button>
                    </div>
                </div>
            </div>
        </el-main>
    </el-container>
</template>
<script>

    import { getCertList, getProductCertList, addProductCert } from "@/api/rbac/certificate";
    export default {
        data() {
            return {
                dataList: [],
                isDialogVisible: false,
                currentData: [],
                certID: 0,
            }
        },
        created() {
            this.getDataList()
        },
        mounted() {
            // 在组件挂载后，设置默认选中
            // this.$nextTick(() => {
            //     this.setDefaultSelections();
            // });
        },
        methods: {
            openDialog(item) {
                this.isDialogVisible = true
                this.getProduct(item.certID)
                this.certID = item.certID
            },
            closeDialog() {
                this.isDialogVisible = false
            },
            getDataList() {
                this.certID = 0
                getCertList({ strWhere: '' }).then(res => {
                    this.dataList = res.data
                })
            },
            getProduct(id) {
                getProductCertList({ strWhere: ' and certID=' + id }).then(res => {
                    this.currentData = []
                    res.data.forEach(row=>{
                        var isCert=false
                        if (row.isCert==1) {
                            isCert=true
                        }
                        this.currentData.push({id:row.id,code:row.code,name:row.name,certID:row.certID,isCert:isCert})
                    })
                })
            },
            // setDefaultSelections() {
            //     this.currentData.forEach(row => {
            //         if (row.isCert === 1) { // 根据状态设置默认选中
            //             this.$refs.multipleTable.toggleRowSelection(row, true);
            //         }
            //     });
            // },
            saveProduct() {
                
                const datarows = []
                this.currentData.forEach(element => {
                    if (element.isCert) {
                        datarows.push({ id: 0, certID: this.certID, productID: element.id, remark: '' })
                    }
                });
                addProductCert(datarows).then(res => {
                    if (res.data == 'ok') {
                        this.isDialogVisible = false;
                        this.currentData = [];
                    }
                })
            }
        }

    }
</script>